/**
 * Invoice Generation API Handler
 */
export default class InvoiceGenerationAPI {
	constructor() {
		this.namespace = 'cancan/invoice-generation/v1';
		this.baseUrl = window.wpApiSettings?.root || '/wp-json/';
		this.nonce = window.wpApiSettings?.nonce || '';
	}

	/**
	 * Generic request handler.
	 *
	 * @param {string} path    REST path relative to namespace.
	 * @param {object} options fetch options.
	 * @returns {Promise<any>}
	 */
	async request(path, options = {}) {
		const { method = 'GET' } = options;
		const url = this.baseUrl + this.namespace + path;

		const headers = {
			'Content-Type': 'application/json',
			...(this.nonce ? { 'X-WP-Nonce': this.nonce } : {}),
			...options.headers,
		};

		console.log(`[IG API] ${method} ${path}`, options.body ? JSON.parse(options.body) : '');

		const response = await fetch(url, { ...options, headers });
		const data = await response.json();

		console.log(response);

		console.log(`[IG API] ${response.status}`, data);

		if (!response.ok) {
			throw new Error(data.message || 'API Error');
		}

		return data;
	}

	/**
	 * Check receipt against the 3rd-party API via the WP REST proxy.
	 *
	 * @param {object} params
	 * @param {string} params.receiptNumber  Kvito Nr.
	 * @param {string} params.registerNumber Kasos aparato Nr.
	 * @param {string} params.date           Kvito data (YYYY-MM-DD).
	 * @param {string} params.amount         Kvito suma.
	 */
	checkReceipt({ receiptNumber, registerNumber, date, amount }) {
		const query = new URLSearchParams({
			'receipt-number': receiptNumber,
			'register-number': registerNumber,
			date,
			amount,
		});
		return this.request(`/check?${query.toString()}`);
	}

	/**
	 * Fetch company data by its registration code.
	 *
	 * @param {string} code
	 */
	fetchCompany(code) {
		const query = new URLSearchParams({ code });
		return this.request(`/company?${query.toString()}`);
	}

	/**
	 * Generate invoice.
	 *
	 * @param {Array}  checks List of receipt objects.
	 * @param {Object} buyer  Buyer information.
	 */
	generateInvoice(checks, buyer) {
		const data = {
			'CHECKS': checks,
			'BUYER': buyer,
		};
		return this.request('/invoice', { method: 'POST', body: JSON.stringify(data) });
	}

	/**
	 * Fetch PDF data (Base64) for a generated invoice.
	 *
	 * @param {Object} invoiceData Data returned from /invoice.
	 */
	generateInvoicePdf(invoiceData) {
		return this.request('/invoicepdf', { method: 'POST', body: JSON.stringify(invoiceData) });
	}
}
